import { render, staticRenderFns } from "./ShopStorePayapiOrder.vue?vue&type=template&id=1ae0d1ec&scoped=true"
import script from "./ShopStorePayapiOrder.vue?vue&type=script&lang=js"
export * from "./ShopStorePayapiOrder.vue?vue&type=script&lang=js"
import style0 from "./ShopStorePayapiOrder.vue?vue&type=style&index=0&id=1ae0d1ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae0d1ec",
  null
  
)

export default component.exports